import { NavLink } from 'react-router-dom';
import { FiGrid, FiUsers, FiShoppingBag, FiBox, FiShield, FiTag, FiSettings, FiRotateCcw, FiDollarSign } from 'react-icons/fi';
import { motion } from 'framer-motion';
import './AdminLayout.css';

const NAV = [
  { to: '/admin/dashboard',  icon: <FiGrid size={17} />,        label: 'Dashboard' },
  { to: '/admin/vendors',    icon: <FiShield size={17} />,      label: 'Vendors' },
  { to: '/admin/orders',     icon: <FiShoppingBag size={17} />, label: 'Orders' },
  { to: '/admin/products',   icon: <FiBox size={17} />,         label: 'Products' },
  { to: '/admin/users',      icon: <FiUsers size={17} />,       label: 'Users' },
  { to: '/admin/categories', icon: <FiTag size={17} />,         label: 'Categories' },
  { to: '/admin/returns',    icon: <FiRotateCcw size={17} />,   label: 'Returns' },
  { to: '/admin/withdrawals',icon: <FiDollarSign size={17} />,  label: 'Withdrawals' },
  { to: '/admin/settings',   icon: <FiSettings size={17} />,    label: 'Settings' },
];

export default function AdminLayout({ children, title, action }) {
  return (
    <div className="alayout">
      <aside className="alayout-sidebar">
        <div className="aadmin-header">
          <div className="aadmin-badge"><FiShield size={18} /></div>
          <div>
            <p className="aadmin-name">Admin Panel</p>
            <span className="badge badge-danger" style={{ fontSize: '0.65rem' }}>Super Admin</span>
          </div>
        </div>

        <nav className="anav">
          {NAV.map(({ to, icon, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => `anav-item${isActive ? ' active' : ''}`}
            >
              {icon}
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="asidebar-footer">
          <NavLink to="/" className="astore-link">← Back to Store</NavLink>
        </div>
      </aside>

      <main className="alayout-main">
        {(title || action) && (
          <div className="alayout-topbar">
            {title && <h1 className="alayout-title">{title}</h1>}
            {action && <div className="alayout-action">{action}</div>}
          </div>
        )}
        <motion.div
          key={title}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.2, ease: 'easeOut' }}
        >
          {children}
        </motion.div>
      </main>
    </div>
  );
}
